import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {Button} from 'wobi-web-common/dist/v2/index.js';

import {apiRequest} from '../../../../utils/apiHelpers';
import {fireGtmEvent} from '../../../../utils/marketing.utils';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';

function FirstStep({ increaseStep, values, hideContactPassportCard }) {
  const intl = useIntl();
  const theme = useTheme();

  const handleButtonClick = (company) => {
    const { firstName1, lastName1, phone1 } = values;
    const data = {
      fullName: firstName1 + ' ' + lastName1,
      phoneNumber: phone1,
      provider: company,
      agentDeveloperName: agentDeveloperUtils.getAgentDeveloperName,
    };

    apiRequest({ endpoint: 'api/callback', data, method: 'POST' })
      .then(increaseStep)
  };

  return (
    <>
      <p style={{
        margin: '12px auto 0',
        fontSize: theme.typography.pxToRem(15.5),
        color: theme.palette.text.primary,
        lineHeight: 1.6,
        maxWidth: 380,
      }}>
        {intl.formatMessage({
          id: hideContactPassportCard ?
            'unsupported_medical_cases_modal.first_step.text_unsupported' :
            'unsupported_medical_cases_modal.first_step.text',
        })}
      </p>
      {hideContactPassportCard ? null : (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 22,
        }}>
          <Button
            variant='primary'
            size='lg'
            onClick={() => {
              fireGtmEvent('ContactPassportcard');
              handleButtonClick('passportcard');
            }}
          >
            {intl.formatMessage({id: 'unsupported_medical_cases_modal.first_step.button1'})}
          </Button>
        </div>
      )}
    </>
  )
}

FirstStep.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  hideContactPassportCard: PropTypes.bool,
};

FirstStep.defaultProps = {
  hideContactPassportCard: false,
};

export default FirstStep;
